exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contact-request-page-css .multi-select-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important;\n  width: 100% !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/contact_request/contact_request.scss
// module id = 982
// module chunks = 1